import { getDictPhrase } from "../../../common/getDictPhrase";
export const getSelectionStatusLabelProps = (selection, state) => {
    return {
        phrase: getDictPhrase(state.dict, `SelectionStatus${selection.settlementStatus}`),
        settlementStatus: selection.settlementStatus
    };
};
//# sourceMappingURL=getSelectionStatusLabelProps.js.map